import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Blog() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'すべて' },
    { id: 'market', name: '市場動向' },
    { id: 'tips', name: '売買のコツ' },
    { id: 'news', name: '会社ニュース' },
    { id: 'area', name: '地域情報' }
  ];

  const blogPosts = [
    {
      id: 1,
      title: '2024年岡山市の不動産市場動向について',
      excerpt: '岡山市の不動産市場は堅調に推移しており、特に北区エリアでの需要が高まっています。最新の市場データを基に、今後の見通しをお伝えします。',
      category: 'market',
      date: '2024年3月15日',
      image: 'https://public.readdy.ai/ai/img_res/92b742be137abfca4cb8f97aea3ef409.jpg',
      author: '岡山 太郎'
    },
    {
      id: 2,
      title: '不動産売却を成功させる5つのポイント',
      excerpt: '不動産売却を検討されている方必見！適正価格での売却を実現するための重要なポイントを、豊富な経験を基にご紹介します。',
      category: 'tips',
      date: '2024年3月10日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20real%20estate%20agent%20showing%20house%20documents%20and%20keys%20to%20satisfied%20clients%2C%20successful%20property%20sale%20meeting%2C%20professional%20consultation%2C%20modern%20office%20setting&width=400&height=250&seq=blog2&orientation=landscape',
      author: '田中 花子'
    },
    {
      id: 3,
      title: '春の住み替えシーズンに向けた準備',
      excerpt: '新年度を迎える春は住み替えの絶好のタイミングです。スムーズな住み替えを実現するための準備と注意点をまとめました。',
      category: 'tips',
      date: '2024年3月5日',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20family%20with%20moving%20boxes%20in%20front%20of%20new%20house%2C%20spring%20season%2C%20cherry%20blossoms%20in%20background%2C%20successful%20home%20relocation%2C%20bright%20and%20cheerful%20atmosphere&width=400&height=250&seq=blog3&orientation=landscape',
      author: '佐藤 次郎'
    },
    {
      id: 4,
      title: '創業24周年を迎えました',
      excerpt: 'おかげさまで、おかやま不動産販売株式会社は創業24周年を迎えることができました。これまでのご愛顧に感謝申し上げます。',
      category: 'news',
      date: '2024年3月1日',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20business%20team%20celebrating%20company%20anniversary%20in%20modern%20office%2C%20group%20photo%20with%20smiles%2C%20corporate%20milestone%20celebration%2C%20formal%20business%20attire&width=400&height=250&seq=blog4&orientation=landscape',
      author: '岡山 太郎'
    },
    {
      id: 5,
      title: '岡山市北区の人気エリア特集',
      excerpt: '岡山市北区の中でも特に人気の高いエリアをピックアップ。交通アクセス、生活環境、将来性などの観点から詳しく解説します。',
      category: 'area',
      date: '2024年2月25日',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20residential%20neighborhood%20in%20Okayama%20city%20with%20tree-lined%20streets%2C%20modern%20houses%2C%20peaceful%20suburban%20environment%2C%20well-maintained%20infrastructure%2C%20family-friendly%20area&width=400&height=250&seq=blog5&orientation=landscape',
      author: '田中 花子'
    },
    {
      id: 6,
      title: '住宅ローン金利動向と今後の見通し',
      excerpt: '住宅ローン金利の最新動向と、今後の見通しについて専門的な視点から解説。マイホーム購入を検討中の方は必見です。',
      category: 'market',
      date: '2024年2月20日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20financial%20advisor%20explaining%20mortgage%20rates%20to%20young%20couple%2C%20professional%20consultation%20with%20charts%20and%20documents%2C%20modern%20bank%20office%2C%20serious%20business%20discussion&width=400&height=250&seq=blog6&orientation=landscape',
      author: '佐藤 次郎'
    },
    {
      id: 7,
      title: '相続不動産の売却手続きガイド',
      excerpt: '相続した不動産の売却は複雑な手続きが必要です。必要書類から税務上の注意点まで、わかりやすく解説します。',
      category: 'tips',
      date: '2024年2月15日',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20elderly%20person%20with%20adult%20children%20discussing%20inheritance%20documents%20at%20table%2C%20family%20meeting%20about%20property%20inheritance%2C%20serious%20consultation%2C%20home%20setting&width=400&height=250&seq=blog7&orientation=landscape',
      author: '岡山 太郎'
    },
    {
      id: 8,
      title: '新スタッフ紹介：営業部に新メンバーが加わりました',
      excerpt: '営業部に新しいスタッフが加わりました。豊富な経験を持つ新メンバーの紹介と、今後の抱負をお伝えします。',
      category: 'news',
      date: '2024年2月10日',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businessman%20in%20suit%20smiling%20confidently%20in%20modern%20office%2C%20new%20employee%20introduction%2C%20welcoming%20workplace%20atmosphere%2C%20business%20portrait&width=400&height=250&seq=blog8&orientation=landscape',
      author: '田中 花子'
    }
  ];

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const getCategoryName = (categoryId: string) => {
    const category = categories.find(cat => cat.id === categoryId);
    return category ? category.name : '';
  };

  useEffect(() => {
    // Set page title and meta description
    document.title = 'ブログ｜不動産お役立ち情報｜おかやま不動産販売株式会社';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '岡山市の不動産に関するお役立ち情報をお届け。売却のコツ、市場動向、税金対策など、不動産取引に役立つ情報を発信しています。');
    }

    // Add structured data
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Blog",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog#blog`,
          "name": "おかやま不動産販売ブログ",
          "description": "不動産売買に関するお役立ち情報",
          "publisher": {
            "@type": "Organization",
            "name": "おかやま不動産販売株式会社",
            "url": import.meta.env.VITE_SITE_URL || 'https://example.com'
          }
        },
        {
          "@type": "WebPage",
          "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog#webpage`,
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/blog`,
          "name": "ブログ｜おかやま不動産販売株式会社",
          "description": "不動産に関するお役立ち情報とニュース",
          "isPartOf": {
            "@id": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`
          }
        }
      ]
    };

    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      
      <main>
        {/* Hero Section */}
        <section className="relative py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">ブログ・新着情報</h1>
              <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
                不動産に関する最新情報やお役立ち情報をお届けします
              </p>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 bg-gray-50 border-b">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap gap-2 justify-center">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-6 py-2 rounded-full font-medium transition-colors whitespace-nowrap ${
                    selectedCategory === category.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-gray-700 hover:bg-blue-50'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article key={post.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                  <div className="h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-3">
                      <span className="px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                        {getCategoryName(post.category)}
                      </span>
                      <span className="text-gray-500 text-sm">{post.date}</span>
                    </div>
                    
                    <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 hover:text-blue-600 transition-colors">
                      <a href={`#blog-${post.id}`}>{post.title}</a>
                    </h2>
                    
                    <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    
                    <div className="flex items-center justify-between">
                      <div className="flex items-center text-sm text-gray-500">
                        <i className="ri-user-line mr-1"></i>
                        <span>{post.author}</span>
                      </div>
                      <a
                        href={`#blog-${post.id}`}
                        className="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors"
                      >
                        続きを読む
                        <i className="ri-arrow-right-line ml-1"></i>
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter Signup */}
        <section className="py-20 bg-blue-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              最新情報をお届け
            </h2>
            <p className="text-xl text-gray-600 mb-8">
              不動産市場の最新動向やお得な情報をメールでお届けします
            </p>
            
            <form 
              className="max-w-md mx-auto flex gap-4"
              onSubmit={(e) => {
                e.preventDefault();
                const email = (e.target as HTMLFormElement).email.value;
                if (email) {
                  alert('ご登録ありがとうございます。最新情報をお送りいたします。');
                  (e.target as HTMLFormElement).reset();
                }
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="メールアドレスを入力"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                required
              />
              <button
                type="submit"
                className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                登録
              </button>
            </form>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-20 bg-blue-600 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              不動産のご相談はお気軽に
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              売却・購入・査定など、どんなことでもお気軽にお問い合わせください
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                メールで相談
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
